import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  whiteSpace: 'pre-line',
  backgroundColor: (theme) => theme.palette.background.paper,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.divider}`,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    lg: '112rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem 1.4rem',
    lg: 0,
  },
  columnGap: {
    lg: '4.8rem',
  },
}

export const accelerateAuthenticTechConnectionLeftSideWrapperSx: SxProps<Theme> =
  {
    margin: { xl: '4.8rem 0' },
    padding: { xs: '2.4rem 0', lg: '8rem 0' },
    paddingBottom: { xs: 0, lg: '8rem' },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 1,
      lg: 'initial',
    },
  }

export const accelerateAuthenticTechConnectionLeftSideContentSx: SxProps<Theme> =
  {
    gap: { xs: '1.6rem', md: '2.4rem' },
  }

export const accelerateAuthenticTechConnectionLeftSideContentDescriptionSx: SxProps<Theme> =
  {
    gap: '1.6rem',
    maxWidth: { lg: '53.2rem', xl: 'unset' },
  }

export const accelerateAuthenticTechConnectionRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 2,
      lg: 'initial',
    },
    borderBottom: (theme) => {
      return {
        xs: `0.1rem solid ${theme.palette.divider}`,
        lg: 0,
      }
    },
    paddingTop: { xs: '1.6rem', lg: 0 },
    paddingBottom: { xs: '2.4rem', lg: 0 },
    margin: { xl: '4.8rem 0' },
  }

export const accelerateAuthenticTechConnectionRightSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      md: '61.2rem',
      lg: '57.2rem',
      xl: '73.4rem',
    },
    maxWidth: {
      xs: '85%',
      md: '61.2rem',
      lg: '57.2rem',
      xl: '73.4rem',
    },
    minHeight: {
      xs: '24.2rem',
      md: '47.4rem',
      lg: '44.4rem',
      xl: '53.2rem',
    },
  }

export const knewHadToBeBetterWayLeftSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: {
    xs: '0 0 1.4rem',
    md: '0 0 2rem',
    lg: '8rem 0',
    xl: '5rem 0 4.6rem',
  },
  order: {
    xs: 4,
    lg: 'initial',
  },
  borderBottom: (theme) => {
    return {
      xs: `0.1rem solid ${theme.palette.divider}`,
      lg: 0,
    }
  },
}

export const knewHadToBeBetterWayLeftSideImageSx: SxProps<Theme> = {
  width: {
    xs: '75%',
    md: '52rem',
    lg: '53.2rem',
  },
  maxWidth: {
    xs: '100%',
    md: '52rem',
    lg: '53.2rem',
  },
  height: '100%',
  minHeight: {
    xs: '24.2rem',
  },
  maxHeight: { xs: '90%', md: '47.4rem', lg: '53.6rem' },
}

export const knewHadToBeBetterWayRightSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  padding: {
    xs: '2.4rem 0 1.4rem',
    md: '2.4rem 0 2rem',
    lg: 0,
  },
  order: {
    xs: 3,
    lg: 'initial',
  },
}

export const knewHadToBeBetterWayRightSideContentSx: SxProps<Theme> = {
  gap: { xs: '1.6rem', md: '2.4rem' },
}

export const knewHadToBeBetterWayRightSideContentDescriptionSx: SxProps<Theme> =
  {
    gap: '1.6rem',
  }

export const theBestPartRightSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  padding: { xs: '2.4rem 0', lg: '8rem 0' },
  order: {
    xs: 7,
    lg: 'initial',
  },
}

export const theBestPartRightSideContentSx: SxProps<Theme> = {
  gap: { xs: '1.6rem', md: '2.4rem' },
}

export const theBestPartRightSideContentDescriptionSx: SxProps<Theme> = {
  gap: '1.6rem',
  maxWidth: { lg: '53.4rem', xl: 'unset' },
}

export const itsAboutYouLeftSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  padding: { xs: '2.4rem 0', lg: '8rem 0', xl: '12.8rem 0' },
  paddingBottom: { xs: 0, lg: '8rem' },
  order: {
    xs: 5,
    lg: 'initial',
  },
}

export const itsAboutYouLeftSideContentSx: SxProps<Theme> = {
  gap: { xs: '1.6rem', md: '2.4rem' },
  paddingBottom: { xs: '1.6rem', lg: 0 },
}

export const itsAboutYouLeftSideContentDescriptionSx: SxProps<Theme> = {
  gap: '1.6rem',
  maxWidth: { lg: '53.4rem', xl: 'unset' },
}

export const itsAboutYouRightSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: { xs: '0 0 3.8rem', md: '0 0 4rem', lg: '8rem 0' },
  order: {
    xs: 6,
    lg: 'initial',
  },
  borderBottom: (theme) => {
    return {
      xs: `0.1rem solid ${theme.palette.divider}`,
      lg: 0,
    }
  },
}

export const theBestSideLeftSideWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: { xs: '0 0 3.4rem', md: '0 0 4.6rem', lg: '8rem 0', xl: '4.8rem 0' },
  order: {
    xs: 8,
    lg: 'initial',
  },
}

export const itsAboutYouRightSideImageSx: SxProps<Theme> = {
  width: {
    xs: '62%',
    md: '45.7rem',
    lg: '54.2rem',
    xl: '59.2rem',
  },
  maxWidth: {
    xs: '100%',
    md: '45.7rem',
    lg: '54.2rem',
    xl: '59.2rem',
  },
  minHeight: {
    xs: '22.6rem',
    md: 'auto',
  },
  maxHeight: { md: '45.7rem', lg: '53.6rem', xl: '54.6rem' },
}

export const theBestPartRightSideImageSx: SxProps<Theme> = {
  width: {
    xs: '66%',
    md: '45.7rem',
    lg: '53.2rem',
  },
  maxWidth: {
    xs: '100%',
    md: '45.7rem',
    lg: '53.2rem',
  },
  maxHeight: { md: '45.7rem', lg: '53.6rem' },
}

export const dividerWrapperSx: SxProps<Theme> = {
  padding: '0 !important',
  order: { md: 9, lg: 'initial' },
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
}
